"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
/**
 * Returns true if the element has the type object
 * @public
 *
 * @param arg - A generic argument to check
 *
 * @returns A boolean indicating whether the arg is an object or not.
 *
 * @example
 * ```ts
 * const result = isObject(undefined);
 * console.log(result);
 * // -> false
 * ```
 **/
function isObject(arg) {
    return typeof arg === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=is-object.js.map